import Vue from "vue";
import Vuex from "vuex";

import { auth, db } from "@/services/firebaseServices.js";
import createPersistedState from "vuex-persistedstate";
import { checkNickname } from "@/services/userServices.js";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    user: null,
    userMetadata: null,
  },
  mutations: {
    logIn(state, payload) {
      state.user = payload.user;
      state.userMetadata = payload.userMetadata;
      state.userSessions = payload.userSessions;
    },
    signOut(state) {
      state.user = null;
      state.userMetadata = null;
      state.userSessions = null;
    },
    saveSession(state, payload) {
      state.userSessions = payload;
    },
    modifyProfile(state, payload) {
      state.user.userData.firstName = payload.firstName;
      state.user.userData.name = payload.name;
      state.user.userData.nickname = payload.nickname;
    },
  },
  actions: {
    async logIn(context, payload) {
      const userEmail = payload.email;
      const userPassword = payload.password;

      const response = await auth.signInWithEmailAndPassword(
        userEmail,
        userPassword
      );
      const userId = response.user.uid;
      const userMetadata = response.user.metadata;
      let userData = "";
      let userSessions = "";

      // fetch user data
      const doc = await db
        .collection("users")
        .doc(userId)
        .get();
      if (doc.exists) {
        userData = doc.data();
      }

      const doc2 = await db
        .collection("sessions")
        .doc(userId)
        .get();
      if (doc2.exists) {
        userSessions = doc2.data();
      }

      context.commit("logIn", {
        user: userData,
        userMetadata: userMetadata,
        userSessions: userSessions,
      });
    },
    signOut(context) {
      context.commit("signOut");
    },
    saveSession(context, payload) {
      const sessionKey = `sessions.${payload.date}`;
      db.collection("sessions")
        .doc(payload.userId)
        .update({
          [sessionKey]: { note: payload.note },
        })
        .then(() => {
          db.collection("sessions")
            .doc(payload.userId)
            .get()
            .then((doc) => {
              if (doc.exists) {
                const userSessions = doc.data();
                context.commit("saveSession", userSessions);
              }
            });
        });
    },
    modifyProfile(context, payload) {
      const checking = checkNickname(payload.nickname);

      checking.then((response) => {
        if (response) {
          db.collection("users")
            .doc(payload.userId)
            .update({
              "userData.firstName": payload.firstName,
              "userData.name": payload.name,
              "userData.nickname": payload.nickname,
            });
          context.commit("modifyProfile", payload);
          console.log("Pseudonyme CHANGED BATARD");
        } else {
          console.log("Pseudonyme déjà utilisé");
        }
      });
    },
  },
  modules: {},
  getters: {
    isUserLoggedIn(state) {
      if (state.user) {
        return true;
      } else return false;
    },
    getAllSessionsDates(state) {
      return Object.keys(state.userSessions.sessions);
    },
  },
});

/* Structure de données users

userId : string
isUserLoggedIn : string
userData {
  email : string
  firstName: string
  name : string
  photo : ?
}

*/
